import { render, staticRenderFns } from "./AttachmentsDropdown.vue?vue&type=template&id=934c3ad0&scoped=true"
import script from "./AttachmentsDropdown.vue?vue&type=script&lang=js"
export * from "./AttachmentsDropdown.vue?vue&type=script&lang=js"
import style0 from "./AttachmentsDropdown.vue?vue&type=style&index=0&id=934c3ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934c3ad0",
  null
  
)

export default component.exports